import { Outlet } from 'react-router-dom';
import { WrapperContainer } from './styled';

export const LayoutLogin = () => {
  return (
    <WrapperContainer>
      {/* <StyledLoginContainer> */}
      <Outlet />
      {/* </StyledLoginContainer> */}
    </WrapperContainer>
  );
};
